import {EmptyImg, LearnMore, Modal} from "@/theme";

export const NewsShowModal = ({isModalOpen, setIsModalOpen, catNip, news}) => {

    return (
        <Modal
            className="news-modal no-border"
            open={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false);
            }}
            style={{
                minWidth: '776px',
                maxWidth: '1100px',
            }}
            footer={null}
            centered
            destroyOnClose={true}
            title={
                <div className={'news_modal_header'}>
                    <p className={'news_title'}>{catNip?.title}</p>
                    <p className={'news_subtitle'}>{catNip?.sub_title}</p>
                </div>
            }
            width={'auto'}
        >
            <div className={'block_catnip'}>
                <div className={'news_left_block'}>
                    {
                        news?.file_path ?
                            <img src={news?.file_path} alt="news-img"/>
                            :
                            <div className={'empty_img'}>
                                <EmptyImg/>
                            </div>
                    }
                </div>
                <div className={'news_right_block'}>
                    <div className={'news_title'}>{news?.title}</div>
                    <span className={'news_author'}>{news?.author}</span>

                    <div className={'news_text'}
                        dangerouslySetInnerHTML={{__html: news?.text}}
                    />

                    {news?.is_active_redirect_btn &&
                        <div className={'news_bottom_block'}>
                            <a href={news?.btn_link}
                               target={"_blank"}
                               className={'news_link'}
                            >
                                <LearnMore/>
                                {news?.btn_name}</a>
                        </div>
                    }
                </div>
            </div>
        </Modal>
    );
};
